module.exports = __webpack_public_path__ + "img/recharge1.a2f22b62.png";